enum ErrorCodes {
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    CONFLICT = 409,
    RATE_LIMIT = 429,
}

export { ErrorCodes };
